
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InternalUser, ExternalUser, Roles, Agency, Users } from '@adminmodel/admin';
import { environment } from '@environment/environment';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class AdminService {
  private baseUrl: string;
  UserID: any;
  SSO: any;
  IPVersion: any;
  BrowserType: any;
  Search: any;

  storedAccessJwtToken = sessionStorage.getItem('token');

  constructor(private http: HttpClient) {
    this.baseUrl = environment.stage.Userservicebaseurl;
  }
  // Method to get the Internal user details
  getInternalUsers(): Observable<InternalUser[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.storedAccessJwtToken}`})
      let options = { headers: headers };
    return this.http.get(this.baseUrl + `/api/Internal`,options).pipe(
      map(response => response as InternalUser[]),
      catchError(handleError),);
  }
  // Method to get External User Details
  getExternalUsers(): Observable<ExternalUser[]> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.storedAccessJwtToken}`})
      let options = { headers: headers };
    return this.http.get(this.baseUrl + `/api/External`,options).pipe(
      map(response => response as ExternalUser[]),
      catchError(handleError),);

  }
  // Method to add new Internal/External users
  postNewUserDetails(newUser: any): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };

    return this.http.post(this.baseUrl + `/api/AddUser`, JSON.stringify(newUser), options).pipe(
      map(response => response));
  } 
  // Method to upload multiple external user details
  AddMultipleExternalUsers(newExternalUsers: any): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };


    return this.http.post(this.baseUrl + `/api/AddMultipleExternal`, JSON.stringify(newExternalUsers), options).pipe(
      map(response => response));
  }
  // Method to search Internal user sso
  internalUserSearch(ssoID: any): Observable<any> {
debugger;
    if (ssoID === '') { ssoID = 0; }
    return this.http.get(this.baseUrl + `/api/ssoSearch/` + <number>ssoID).pipe(
      map(response => response as any),
      catchError(handleError),);
  }
  // Method to check whether the Internal/external user email id exists
  userEmailSearch(emailID: any): Observable<any> {
    return this.http.get(this.baseUrl + `/api/emailSearch/` + emailID).pipe(
      map(response => response as any),
      catchError(handleError),);
  }

  // method to update Internal/external user details
  updateUserDetails(updatedUserDetails: any): Observable<any> {

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/UpdateUser/` + updatedUserDetails.userAgencyMapID, JSON.stringify(updatedUserDetails), options).pipe(
      map(response => response as any));
  }
  // Method to get the User Roles
  getUserRoles() {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.storedAccessJwtToken}`})
      let options = { headers: headers };
    return this.http.get(this.baseUrl + `/api/Role`,options).pipe(
      map(response => response as Roles[]),
      catchError(handleError),);
  }
  // Method to get the agency list
  getAgencyList() {
    return this.http.get(this.baseUrl + `/api/Agency`).pipe(
      map(response => response as Agency[]),
      catchError(handleError),);
  }

  // Method to get the User Log Details
  getLogUserDetails(): Observable<any> {
    return this.http.get(this.baseUrl + `/api/GetLogUser`).pipe(
      map(response => response as any),
      catchError(handleError),);
  }
  // Method to add User Log Details
  LogNewUserDetails(LognewUser: any): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };

    return this.http.post(this.baseUrl + `/api/LogUser`, JSON.stringify(LognewUser), options).pipe(
      map(response => response as any));
  }
  // method to update Log out user details

  LogUserUpdateDetails(LognewUser: any): Observable<any> {

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/UpdateLogUser`, JSON.stringify(LognewUser), options).pipe(
      map(response => response as any));
  }
  UpdateLogOutTimeUserLog(LognewUser: any): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/UpdateLogOutTimeUserLog`, JSON.stringify(LognewUser), options).pipe(
      map(response => response as any));
  }
  // Method to get user details by sso
  getUserDetailsBySSO(ssoID: any): Observable<any[]> {
debugger;
    if (ssoID === '') { ssoID = 0; }
    return this.http.get(this.baseUrl + `/api/UserDetails/` + <number>ssoID).pipe(
      map(response => response as any[]),
      catchError(handleError),);
  }

  // method to validate user type
  getUserRoleID(SSO: any): Observable<Users[]> {
    
    return this.http.get(this.baseUrl + `/api/UserRoleID/` + SSO).pipe(
      map(response => response as Users[]),
      catchError(handleError),);
  }
  // Method to search user exist or not

  searchUser(userID: any, ipVersion: any, browserType: any): Observable<any> {

    this.UserID = userID;
    this.IPVersion = ipVersion;
    this.BrowserType = browserType;
    return this.http.get(this.baseUrl + `/api/UserExistSearch/` + this.UserID + '/' + this.IPVersion + '/' + this.BrowserType).pipe(
      map(response => response as any),
      catchError(handleError),);
  }

  getUserDetailsFromSSOId(ssoId: any): Observable<Users> {
    
    return this.http.get(this.baseUrl + `/api/UserDetailsFromSSOId/` + ssoId).pipe(
      map(response => response as Users),
      catchError(handleError),);
  }

  CheckExternalUserAgencyExist(requestData: any): Observable<any> {
    // debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };

    return this.http.post(this.baseUrl + `/api/CheckExternalUserAgencyExist`, JSON.stringify(requestData), options).pipe(
      map(response => response as any),
      catchError(handleError),);
  }

}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);

  // throw an application level error
  return observableThrowError(errorMsg);
}
